/* eslint-disable func-names */
/* eslint-disable react/no-this-in-sfc */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable react/prop-types */
/* eslint-disable no-nested-ternary */
import React, { useEffect, useRef, useState } from 'react';
import { Form, Formik } from 'formik';
import * as Yup from 'yup';
import lottie from 'lottie-web';

import adminServices from '../../../services/adminServices';
import SnackBar from '../../../components/snackbar/snackbar';
import lottieData from '../../../assets/lottie/lottie-loading.json';
import '../../../components/PhoneNumber/styles.css';


const Label = ({ children, required, htmlFor }) => (
  <label
    htmlFor={htmlFor}
    className="block text-[13px] font-semibold text-gray-800 mb-1"
  >
    {children}
    {required && <span className="text-red-500 ml-0.5">*</span>}
  </label>
);

const Input = ({ error, className = '', ...props }) => (
  <input
    className={`w-full border ${error ? 'border-red-400' : 'border-gray-300'} rounded px-3 py-[7px] text-[13px] text-gray-800 placeholder-gray-400 focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-500 bg-white transition ${className}`}
    {...props}
  />
);

const ErrMsg = ({ msg }) =>
  msg ? <p className="mt-1 text-[11px] text-red-500">{msg}</p> : null;

const SectionHeader = ({ children }) => (
  <div className="pt-2 pb-1">
    <p className="text-[10px] font-bold text-gray-400 uppercase tracking-widest">{children}</p>
  </div>
);

const SelectField = ({ options = [], value, onChange, placeholder, error, getLabel = (o) => o?.label || o?.description || o || '' }) => {
  const [open, setOpen] = useState(false);
  const [search, setSearch] = useState('');
  const ref = useRef();

  const filtered = options.filter((o) =>
    getLabel(o).toLowerCase().includes(search.toLowerCase())
  );
  const displayValue = value ? getLabel(value) : '';

  useEffect(() => {
    const handler = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, []);

  return (
    <div className="relative" ref={ref}>
      <button
        type="button"
        // role="combobox"
        aria-expanded={open}
        aria-haspopup="listbox"
        className={`w-full flex items-center border ${error ? 'border-red-400' : 'border-gray-300'} rounded px-3 py-[7px] text-[13px] bg-white focus:outline-none focus:ring-1 focus:ring-blue-500`}
        onClick={() => { setOpen((o) => !o); setSearch(''); }}
      >
        <svg className="w-3.5 h-3.5 text-gray-400 mr-2 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <circle cx="11" cy="11" r="8" strokeWidth="2" />
          <path d="M21 21l-4.35-4.35" strokeWidth="2" strokeLinecap="round" />
        </svg>
        <span className={`flex-1 text-left truncate ${displayValue ? 'text-gray-800' : 'text-gray-400'}`}>
          {displayValue || placeholder || 'Select…'}
        </span>
        <svg className={`w-3.5 h-3.5 text-gray-500 ml-1 transition-transform ${open ? 'rotate-180' : ''}`} fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7" />
        </svg>
      </button>

      {open && (
        <div className="absolute z-50 w-full mt-1 bg-white border border-gray-200 rounded shadow-lg max-h-48 overflow-hidden flex flex-col">
          <div className="p-2 border-b border-gray-100">
            <input
              className="w-full text-[12px] px-2 py-1 border border-gray-200 rounded focus:outline-none focus:ring-1 focus:ring-blue-400"
              placeholder="Search…"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              onClick={(e) => e.stopPropagation()}
            />
          </div>
          <ul role="listbox" className="overflow-y-auto flex-1">
            {filtered.length === 0 && (
              <li className="px-3 py-2 text-[12px] text-gray-400">No options</li>
            )}
            {filtered.map((opt, i) => (
              <li key={i} role="option" aria-selected={getLabel(opt) === displayValue}>
                <button
                  type="button"
                  className={`w-full text-left px-3 py-2 text-[13px] hover:bg-blue-50 ${getLabel(opt) === displayValue ? 'bg-blue-100 text-blue-700 font-medium' : 'text-gray-700'}`}
                  onClick={() => { onChange(opt); setOpen(false); setSearch(''); }}
                >
                  {getLabel(opt)}
                </button>
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
};

const ToggleModeSelect = ({ value, onChange, disabled = false }) => {
  const options = [
    {
      label: "Run Only",
      value: "RUN_ONLY",
      description: "Can run existing assessments",
    },
    {
      label: "Full Creator",
      value: "FULL_CREATOR",
      description: "Can create and run assessments",
    },
  ];

  return (
    <div style={{ display: "flex", gap: "16px" }}>
      {options.map((opt) => {
        const isActive = value === opt.value;

        return (
          <button
            key={opt.value}
            type="button"
            onClick={() => !disabled && onChange(opt.value)}
            disabled={disabled}
            style={{
              flex: 1,
              padding: "16px",
              borderRadius: "10px",
              cursor: disabled ? "not-allowed" : "pointer",
              border: isActive ? "2px solid #2563eb" : "1px solid #d1d5db",
              backgroundColor: disabled ? "#f3f4f6" : isActive ? "#f1f5f9" : "#fff",
              textAlign: "left",
              opacity: disabled ? 0.6 : 1,
            }}
          >
            <div style={{ fontWeight: 600, fontSize: "16px" }}>
              {opt.label}
            </div>

            <div
              style={{
                fontSize: "13px",
                color: "#6b7280",
                marginTop: "4px",
              }}
            >
              {opt.description}
            </div>
          </button>
        );
      })}
    </div>
  );
};

const FocusError = ({ errors, isSubmitting, isValidating }) => {
  useEffect(() => {
    if (isSubmitting && !isValidating) {
      const firstErrorKey = Object.keys(errors)[0];
      if (firstErrorKey) {
        const el = document.querySelector(`[name="${firstErrorKey}"]`);
        if (el) {
          el.focus();
          el.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      }
    }
  }, [isSubmitting, isValidating, errors]);

  return null;
};

const LogoUpload = ({ preview, onFile, onRemove, error, onError }) => {
  const inputRef = useRef();
  const SUPPORTED_FORMATS = ['image/jpg', 'image/jpeg', 'image/png'];

  const processFile = (file) => {
    if (!file) return;
    if (!SUPPORTED_FORMATS.includes(file.type)) {
      if (onError) onError('Only PNG, JPG formats are supported.');
      return;
    }
    if (file.size > 512000) {
      if (onError) onError('Logo must be less than 500KB.');
      return;
    }
    if (onError) onError('');
      const url = URL.createObjectURL(file);
      onFile(file, url);
  };

  return (
    <>
      <input
        type="file"
        ref={inputRef}
        className="hidden"
        accept="image/png,image/jpeg,image/jpg"
        onChange={(e) => processFile(e.target.files[0])}
      />
      {preview ? (
        <div className="relative inline-block">
          <img src={preview} alt="Logo" className="h-16 rounded-md border border-gray-200" />
          <button
            type="button"
            onClick={onRemove}
            className="absolute -top-1.5 -right-1.5 w-5 h-5 bg-red-500 text-white rounded-full text-xs flex items-center justify-center"
          >
            ×
          </button>
        </div>
      ) : (
        <div
          role="button"
          tabIndex={0}
          onClick={() => inputRef.current?.click()}
          onKeyDown={(e) => {
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault();
              inputRef.current?.click();
            }
          }}
          onDragOver={(e) => e.preventDefault()}
          onDrop={(e) => { e.preventDefault(); processFile(e.dataTransfer.files[0]); }}
          className={`border-2 border-dashed ${error ? 'border-red-400' : 'border-gray-300'} rounded-lg p-6 flex flex-col items-center justify-center cursor-pointer hover:border-blue-400 hover:bg-blue-50/30 transition-colors`}
        >
          <svg className="w-6 h-6 text-gray-400 mb-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5"
              d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-8l-4-4m0 0L8 8m4-4v12" />
          </svg>
          <p className="text-[12px] text-gray-500">
            <span className="text-blue-500 font-medium">Click to upload</span> or drag and drop
          </p>
          <p className="text-[11px] text-gray-400 mt-0.5">PNG, JPG · max 500KB</p>
        </div>
      )}
    </>
  );
};

const AdminRow = ({ name, email }) => (
  <div className="flex items-center justify-between border border-gray-200 rounded-lg px-3 py-2.5 bg-gray-50">
    <div className="flex items-center gap-2.5">
      <div className="w-7 h-7 rounded-full bg-gray-200 flex items-center justify-center text-[11px] text-gray-500 font-medium">
        {name?.[0]?.toUpperCase() || '?'}
      </div>
      <div>
        <p className="text-[13px] font-medium text-gray-800 leading-none">{name}</p>
        <p className="text-[11px] text-gray-400 mt-0.5">{email}</p>
      </div>
    </div>
    <span className="text-[11px] text-gray-400 font-medium">Assigned</span>
  </div>
);


export default function AddClientForm({ toggle, mode, clientDetails,clientId, getClientList, snackBarControl }) {
  const lottoLoad = useRef();

  const SUPPORTED_FORMATS = ['image/jpg', 'image/jpeg', 'image/png'];

  const [formValues, setFormValues] = useState({
    organizationName: '',
    clientAdminName: '',
    clientAdminEmail: '',
    featureToggleMode: 'RUN_ONLY',
    slug: '',
    address1: '',
    address2: '',
    country: '',
    selectState: '',
    city: '',
    zipcode: '',
    websiteUrl: '',
    contactName: '',
    contactEmail: '',
    phone: '',
    officeNumber: '',
    dateFormat: '',
    timeZone: '',
    thumbImage: null,
    thumbImagePreview: null,
    clientAdmin: null,
    contractLearnerSeats: '',
    contractCreatorSeats: '',
    contractStartDate: '',
    contractEndDate: '',
    contractNotes: '',
    contractAmount: '',
    contractCurrency: '',
    trialPeriodDays: '',
    couponCode: '',
    payNow: false,
    logoError: '',
  });

  const [countryCode, setCountryCode] = useState(null);
  const [countryCodeDesc, setCountryCodeDesc] = useState(null);
  const [country, setCountry] = useState([]);
  const [loading, setLoading] = useState(false);
  const [stateList, setStateList] = useState([]);
  const [dateFormatList, setDateFormatList] = useState([]);
  const [timezoneList, setTimezoneList] = useState([]);
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarTitle, setSnackbarTitle] = useState('');
  const [lottieLoading, setLottieLoading] = useState(true);


 

  const handleAddClientFormValues = async (values) => {
    setLoading(true);
    const formData = new FormData();
    formData.append('organizationName', values.organizationName);
    formData.append('clientAdminName', values.clientAdminName);
    formData.append('clientAdminEmail', values.clientAdminEmail);
    formData.append('featureToggleMode', values.featureToggleMode);
    if (values.featureToggleMode === 'FULL_CREATOR') {
      formData.append('slug', values.slug);
      formData.append('schemaName', `tenant_${values.slug.replace(/-/g, '_')}`);
    }
    formData.append('address1', values.address1);
    formData.append('address2', values.address2);

    formData.append('city', values.city);
    formData.append('zipCode', values.zipcode);
    formData.append('websiteUrl', values.websiteUrl || '');
    formData.append('contactName', values.contactName);
    formData.append('contactEmail', values.contactEmail);
    formData.append('contactPhone', values.phone);
    formData.append('officeNumber', values.officeNumber || '');
    formData.append('dateFormat', values.dateFormat?.code || values.dateFormat);
    formData.append('timeZone', values.timeZone?.code || values.timeZone);
    formData.append('country', values.country?.code || values.country);
    formData.append('state', values.selectState?.code || values.selectState);
    if (values.thumbImage) formData.append('logo', values.thumbImage);

    // Contract fields
    if (values.contractLearnerSeats !== '') formData.append('contractLearnerSeats', values.contractLearnerSeats);
    if (values.featureToggleMode === 'FULL_CREATOR' && values.contractCreatorSeats !== '') {
      formData.append('contractCreatorSeats', values.contractCreatorSeats);
    }
    if (values.contractStartDate) formData.append('contractStartDate', values.contractStartDate);
    if (values.contractEndDate) formData.append('contractEndDate', values.contractEndDate);
    if (values.contractNotes) formData.append('contractNotes', values.contractNotes);
    if (values.contractAmount) formData.append('contractAmount', values.contractAmount);
    if (values.contractCurrency) formData.append('contractCurrency', values.contractCurrency);
    if (values.couponCode) formData.append('couponCode', values.couponCode);
    formData.append('payNow', values.payNow);
    if (!values.payNow && values.trialPeriodDays) formData.append('trialPeriodDays', values.trialPeriodDays);

    if (mode === 'create') {
      try {
        const response = await adminServices.postClientDetails(formData);
        if (response.ok) {
          getClientList();
          toggle();
          snackBarControl(response.data.message || 'Client created successfully.');
        } else {
          const errMsg = response.data.error || response.data.message || 'Something went wrong. Please try again.';
          setOpenSnackbar(true);
          setSnackbarTitle(errMsg);
          snackBarControl(errMsg);
        }
      } catch (error) {
        console.error('[AddClientForm] Unexpected error:', error);
        setOpenSnackbar(true);
        setSnackbarTitle('An unexpected error occurred. Please try again.');
      }
    } else {
      try {
        const res = await adminServices.editClientDetailsByID(clientId, formData);
        if (res.ok) {
          setOpenSnackbar(true);
          setSnackbarTitle(res.data.message);
          snackBarControl(res.data.message);
          toggle();
          getClientList(true);
        } else {
          const errMsg = res.data.error || res.data.message || 'Something went wrong';
          setOpenSnackbar(true);
          setSnackbarTitle(errMsg);
          snackBarControl(errMsg);
        }
      } catch (error) {
        console.log(error);
        setOpenSnackbar(false);
      }
    }
    setLoading(false);
  };


  const getClientDetailsById = async () => {
    const [result, contractRes] = await Promise.all([
      adminServices.getClientDetalsById(clientId),
      adminServices.getClientContract(clientId),
    ]);
    if (result.ok) {
      const data = { ...formValues };
      data.organizationName = result.data.organizationName;
      data.featureToggleMode = result.data.featureToggleMode || 'run_only';
      data.address1 = result.data.address1;
      data.address2 = result.data.address2;
      data.country = result.data.country;
      setCountryCode(result.data.country?.code);
      setCountryCodeDesc(result.data.country?.description);
      data.selectState = result.data.state;
      data.city = result.data.city;
      data.zipcode = result.data.zipCode;
      data.websiteUrl = result.data.websiteUrl;
      data.contactName = result.data.contactName;
      data.contactEmail = result.data.contactEmail;
      data.phone = result.data.contactPhone;
      data.officeNumber = result.data.officeNumber;
      data.dateFormat = result.data.dateFormat;
      data.timeZone = result.data.timeZone;
      data.thumbImage = null;
      data.thumbImagePreview = result.data.logo;
      data.clientAdminName = result.data.clientAdminName;
      data.clientAdminEmail = result.data.clientAdminEmail;
      data.featureToggleMode = result.data.featureToggleMode;
      data.slug = result.data.slug || '';
      // Contract data
      if (contractRes.ok && contractRes.data) {
        const c = contractRes.data;
        data.contractLearnerSeats = c.learnerSeats ?? '';
        data.contractCreatorSeats = c.creatorSeats ?? '';
        data.contractStartDate = c.startDate ? new Date(c.startDate).toLocaleDateString('en-CA') : '';
        data.contractEndDate = c.endDate ? new Date(c.endDate).toLocaleDateString('en-CA') : '';
      //  data.contractStartDate = c.startDate ? c.startDate.slice(0, 10) : '';
      //  data.contractEndDate = c.endDate ? c.endDate.slice(0, 10) : '';
        data.contractNotes = c.notes || '';
        data.trialPeriodDays = c.trialEndDate && c.startDate ? Math.round((new Date(new Date(c.trialEndDate).toLocaleDateString('en-CA')) - new Date(new Date(c.startDate).toLocaleDateString('en-CA'))) / 86400000): '';      
      }
      setFormValues(data);
    }
    setLottieLoading(false);
  };

  const getLookUpDetails = async () => {
    const key = ['country', 'state', 'date_format', 'timezone'];
    const response = await adminServices.getLookUpData(key);
    if (response.ok) {
      setStateList(response.data.state);
      setDateFormatList(response.data.date_format);
      setTimezoneList(response.data.status);
      setCountry(response.data.country);
    }
  };

  const getLookUpState = async () => {
    const key = ['country', 'state', 'date_format', 'timezone'];
    const response = await adminServices.getLookUpStateData(key, countryCode, countryCodeDesc);
    if (response) {
      setStateList(response.data.state);
    }
  };

  useEffect(() => {
    getLookUpDetails();
    if (mode === 'edit') {
      getClientDetailsById();
    } else {
      setLottieLoading(false);
    }
  }, []);

  useEffect(() => {
    if (countryCode !== null && countryCodeDesc !== null) {
      getLookUpState();
    }
  }, [countryCode, countryCodeDesc]);

  useEffect(() => {
    if (lottoLoad.current) {
      lottie.loadAnimation({
        container: lottoLoad.current,
        renderer: 'svg',
        loop: true,
        autoplay: true,
        animationData: lottieData,
      });
    }
  }, []);


  return (
    <>
      <Formik
        enableReinitialize
        initialValues={formValues}
        validationSchema={Yup.object().shape({
          organizationName: Yup.string()
            .trim().nullable()
            .min(3, 'Company name contains at least 3 characters')
            .required('Company name is required')
            .matches(/^[A-Za-z ]+$/, 'Only alphabets are allowed'),
          clientAdminName: Yup.string()
            .trim().nullable()
            .when([], {
              is: () => mode === 'create',
              then: Yup.string()
                .min(3, 'Admin name contains at least 3 characters')
                .required('Client Admin Name is required')
                .matches(/^[A-Za-z ]+$/, 'Only alphabets are allowed'),
              otherwise: Yup.string().nullable(),
            }),
          clientAdminEmail: Yup.string()
            .trim().nullable()
            .when([], {
              is: () => mode === 'create',
              then: Yup.string()
                .email('Must be a valid email')
                .required('Client Admin Email is required'),
              otherwise: Yup.string().nullable(),
            }),
          slug: Yup.string()
            .when('featureToggleMode', {
              is: 'FULL_CREATOR',
              then: Yup.string()
                .trim()
                .required('Slug is required')
                .min(3, 'Slug must be at least 3 characters')
                .max(50, 'Slug must be at most 50 characters')
                .matches(/^[a-z]+$/, 'Slug must contain only lowercase letters,no special characters or spaces'),
              otherwise: Yup.string().nullable(),
            }),
          address1: Yup.string()
            .trim().nullable()
            .min(3, 'Address 1 contains at least 3 characters')
            .required('Address 1 is required'),
          country: Yup.object().nullable().required('Country is required'),
          selectState: Yup.object().nullable(),
          city: Yup.string()
            .trim().nullable()
            .min(3, 'City contains at least 3 characters')
            .required('City is required'),
          zipcode: Yup.string().trim().min(5, 'Invalid Zip Code').max(9).required('Zip Code is required'),
          officeNumber: Yup.string().trim().nullable(),
          websiteUrl: Yup.string().trim().nullable(),
          contactName: Yup.string()
            .trim().nullable()
            .min(3, 'Contact name contains at least 3 characters')
            .matches(/^[A-Za-z ]+$/, 'Only alphabets are allowed')
            .required('Contact name is required'),
          contactEmail: Yup.string()
            .trim().nullable()
            .required('Contact email is required')
            .email('Must be a valid email'),
          phone: Yup.string()
            .trim().nullable()
            .min(10, 'Contact phone must be at least 10 characters')
            .max(12, 'Contact phone must be within 12 numbers')
            .required('Contact phone is required'),
          timeZone: Yup.object().nullable().required('Timezone is required'),
          dateFormat: Yup.object().nullable().required('Date format is required'),
          contractLearnerSeats: Yup.number().nullable().min(0, 'Must be 0 or more'),
          contractCreatorSeats: Yup.number()
            .nullable()
            .min(0, 'Must be 0 or more')
            .when('featureToggleMode', {
              is: 'FULL_CREATOR',
              then: Yup.number().nullable().max(10, 'Content Creator Seats cannot exceed 10'),
              otherwise: Yup.number().nullable(),
            }),
          contractStartDate: Yup.string().nullable(),
          contractEndDate: Yup.string()
            .nullable()
            .test('date-order', 'End date must be after start date', function (endDate) {
              const { contractStartDate } = this.parent;
              if (!contractStartDate || !endDate) return true;
              return endDate >= contractStartDate;
            }),
          contractNotes: Yup.string().nullable(),
          thumbImagePreview: Yup.string().nullable(),
          thumbImage: Yup.mixed()
            .nullable()
            .when('thumbImagePreview', {
              is: null,
              then: Yup.mixed()
                .nullable()
                .test('fileFormat', 'Unsupported Format', (v) => v === null || (v && SUPPORTED_FORMATS.includes(v.type)))
                .test('fileSize', 'Maximum file size is 500KB', (v) => v === null || (v && v.size <= 512000)),
              otherwise: Yup.mixed().nullable(),
            }),
        })}
        onSubmit={(values) => handleAddClientFormValues(values)}
      >
        {({ values, errors, touched, handleBlur, handleChange, setFieldValue, isSubmitting, isValidating }) => (
          <Form className="flex flex-col h-full">
            <FocusError errors={errors} isSubmitting={isSubmitting} isValidating={isValidating} />
            {mode === 'edit' && lottieLoading ? (
              <div className="flex items-center justify-center py-16">
                <div style={{ width: 50 }} ref={lottoLoad} />
              </div>
            ) : (
              <div className="flex-1 overflow-y-auto px-5 py-4 space-y-5">

                <SectionHeader>Client Setup</SectionHeader>

                <div>
                  <Label required htmlFor="organizationName">Client Name</Label>
                  <Input
                    id="organizationName"
                    name="organizationName"
                    type="text"
                    value={values.organizationName}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    maxLength={180}
                    placeholder="e.g. Akash Institute Delhi"
                    error={touched.organizationName && errors.organizationName}
                  />
                  <ErrMsg msg={touched.organizationName && errors.organizationName} />
                </div>

                {mode === 'create' && (
                  <div className="space-y-3">
                    <div className="pt-1">
                      <p className="text-[10px] font-bold text-gray-400 uppercase tracking-widest">Client Admin</p>
                      <p className="text-[12px] text-gray-500 mt-0.5">Invite an admin and an email will be sent to them post creation.</p>
                    </div>

                    <div>
                      <Label required htmlFor="clientAdminName">Client Admin Name</Label>
                      <Input
                        id="clientAdminName"
                        name="clientAdminName"
                        type="text"
                        value={values.clientAdminName}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        placeholder="e.g. Raj Sharma"
                        error={touched.clientAdminName && errors.clientAdminName}
                      />
                      <ErrMsg msg={touched.clientAdminName && errors.clientAdminName} />
                    </div>

                    <div>
                      <Label required htmlFor="clientAdminEmail">Client Admin Email</Label>
                      <Input
                        id="clientAdminEmail"
                        name="clientAdminEmail"
                        type="email"
                        value={values.clientAdminEmail}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        placeholder="e.g. raj@akashinstitute.com"
                        error={touched.clientAdminEmail && errors.clientAdminEmail}
                      />
                      <ErrMsg msg={touched.clientAdminEmail && errors.clientAdminEmail} />
                    </div>
                  </div>
                )}

                <div>
                  <Label required htmlFor="featureToggleMode">Feature Mode</Label>
                  <ToggleModeSelect
                    value={values.featureToggleMode}
                    onChange={(val) => setFieldValue('featureToggleMode', val)}
                    disabled={mode === 'edit'}
                  />
                  <ErrMsg msg={touched.featureToggleMode && errors.featureToggleMode} />
                    {mode === 'edit' && (
                      <p className="mt-1 text-[11px] text-gray-400">Feature mode cannot be changed after creation.</p>
                    )}
                </div>

                {values.featureToggleMode === 'FULL_CREATOR' && (
                  <div className="border border-blue-100 bg-blue-50/40 rounded-lg p-4 space-y-3">
                    <p className="text-[10px] font-bold text-blue-600 uppercase tracking-widest">Tenant Configuration</p>
                    <p className="text-[12px] text-gray-500 -mt-1">These fields provision a dedicated schema for this client. All fields are required.</p>

                    <div>
                      <Label required htmlFor="slug">Tenant Slug</Label>
                      <Input
                        id="slug"
                        name="slug"
                        type="text"
                        value={values.slug}
                        onChange={(e) => {
                          const val = e.target.value.toLowerCase().replace(/[^a-z]/g, '');
                          handleChange({ target: { name: 'slug', value: val } });
                        }}
                        onBlur={handleBlur}
                        placeholder="e.g. myclientorg"
                        error={touched.slug && errors.slug}
                        disabled={mode === 'edit'}
                      />
                      <ErrMsg msg={touched.slug && errors.slug} />
                      {mode === 'edit' && <p className="mt-1 text-[11px] text-gray-400">Slug cannot be changed after creation.</p>}
                      {values.slug && mode === 'create' && (
                        <p className="mt-1 text-[11px] text-gray-500">Schema: <span className="font-mono">tenant_{values.slug.replace(/-/g, '_')}</span></p>
                      )}
                    </div>
                  </div>
                )}

                <div>
                  <Label htmlFor="thumbImage">
                    Logo <span className="text-[11px] text-gray-400 normal-case font-normal">(optional)</span>
                  </Label>
                  <LogoUpload
                    preview={values.thumbImagePreview}
                    onFile={(file, url) => {
                      setFieldValue('thumbImage', file);
                      setFieldValue('thumbImagePreview', url);
                    }}
                    onRemove={() => {
                      setFieldValue('thumbImage', null);
                      setFieldValue('thumbImagePreview', null);
                      setFieldValue('logoError', '');
                    }}
                    onError={(msg) => setFieldValue('logoError', msg)}
                    error={values.logoError || (touched.thumbImagePreview && errors.thumbImage)}
                  />
                  <ErrMsg msg={values.logoError || (touched.thumbImage && errors.thumbImage)} />
                </div>

                <SectionHeader>Client Profile</SectionHeader>

                <div className="space-y-3">
                  <div>
                    <Label required htmlFor="contactName">Contact Name</Label>
                    <Input
                      id="contactName"
                      name="contactName"
                      type="text"
                      value={values.contactName}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      placeholder="Primary contact at this organisation"
                      error={touched.contactName && errors.contactName}
                    />
                    <ErrMsg msg={touched.contactName && errors.contactName} />
                  </div>

                  <div className="grid grid-cols-2 gap-3">
                    <div>
                      <Label required htmlFor="contactEmail">Contact Email</Label>
                      <Input
                        id="contactEmail"
                        name="contactEmail"
                        type="email"
                        value={values.contactEmail}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        placeholder="contact@org.com"
                        error={touched.contactEmail && errors.contactEmail}
                      />
                      <ErrMsg msg={touched.contactEmail && errors.contactEmail} />
                    </div>
                    <div>
                      <Label required htmlFor="phone">Contact Phone</Label>
                      <Input
                        id="phone"
                        name="phone"
                        type="text"
                        value={values.phone}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        placeholder="+91 XXXXX XXXXX"
                        error={touched.phone && errors.phone}
                      />
                      <ErrMsg msg={touched.phone && errors.phone} />
                    </div>
                  </div>

                  <div className="grid grid-cols-2 gap-3">
                    <div>
                      <Label required htmlFor="timeZone">Timezone</Label>
                      <SelectField
                        options={timezoneList}
                        value={values.timeZone}
                        onChange={(val) => setFieldValue('timeZone', val)}
                        placeholder="Select timezone"
                        error={touched.timeZone && errors.timeZone}
                        getLabel={(o) => o?.description || o?.label || o || ''}
                      />
                      <ErrMsg msg={touched.timeZone && errors.timeZone} />
                    </div>
                    <div>
                      <Label required htmlFor="dateFormat">Date Format</Label>
                      <SelectField
                        options={dateFormatList}
                        value={values.dateFormat}
                        onChange={(val) => setFieldValue('dateFormat', val)}
                        placeholder="Select date format"
                        error={touched.dateFormat && errors.dateFormat}
                        getLabel={(o) => o?.description || o?.code || o || ''}
                      />
                      <ErrMsg msg={touched.dateFormat && errors.dateFormat} />
                    </div>
                  </div>
                </div>

                <SectionHeader>Address</SectionHeader>

                <div className="space-y-3">
                  <div>
                    <Label required htmlFor="address1">Address Line 1</Label>
                    <Input
                      id="address1"
                      name="address1"
                      type="text"
                      value={values.address1}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      placeholder="Building, street, area"
                      error={touched.address1 && errors.address1}
                    />
                    <ErrMsg msg={touched.address1 && errors.address1} />
                  </div>

                  <div>
                    <Label htmlFor="address2">Address Line 2</Label>
                    <Input
                      id="address2"
                      name="address2"
                      type="text"
                      value={values.address2}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      placeholder="Suite, floor, landmark (optional)"
                    />
                  </div>

                  <div className="grid grid-cols-2 gap-3">
                    <div>
                      <Label required htmlFor="country">Country</Label>
                      <SelectField
                        options={country}
                        value={values.country}
                        onChange={(val) => {
                          setFieldValue('country', val);
                          setFieldValue('selectState', '');
                          setCountryCode(val?.code);
                          setCountryCodeDesc(val?.description);
                        }}
                        placeholder="Select country"
                        error={touched.country && errors.country}
                      />
                      <ErrMsg msg={touched.country && errors.country} />
                    </div>
                    <div>
                      <Label htmlFor="selectState">State</Label>
                      <SelectField
                        options={stateList}
                        value={values.selectState}
                        onChange={(val) => setFieldValue('selectState', val)}
                        placeholder="Select state"
                        error={touched.selectState && errors.selectState}
                      />
                      <ErrMsg msg={touched.selectState && errors.selectState} />
                    </div>
                  </div>

                  {/* City + Zip Code */}
                  <div className="grid grid-cols-2 gap-3">
                    <div>
                      <Label required htmlFor="city">City</Label>
                      <Input
                        id="city"
                        name="city"
                        type="text"
                        value={values.city}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        placeholder="City"
                        error={touched.city && errors.city}
                      />
                      <ErrMsg msg={touched.city && errors.city} />
                    </div>
                    <div>
                      <Label required htmlFor="zipcode">Zip Code</Label>
                      <Input
                        id="zipcode"
                        name="zipcode"
                        type="text"
                        value={values.zipcode}
                        onChange={(e) => {
                          e.target.value = e.target.value.replace(/[^0-9]/g, '');
                          handleChange(e);
                        }}
                        onBlur={handleBlur}
                        placeholder="000000"
                        maxLength={9}
                        error={touched.zipcode && errors.zipcode}
                      />
                      <ErrMsg msg={touched.zipcode && errors.zipcode} />
                    </div>
                  </div>
                </div>

                {mode === 'edit' && (
                  <div className="space-y-2">
                    <Label>Client Admin</Label>
                    {clientDetails?.clientAdmin ? (
                      <AdminRow
                        name={clientDetails?.clientAdmin?.fullName}
                        email={clientDetails?.clientAdmin?.email}
                      />
                    ) : (
                      <p className="text-[12px] text-gray-400 italic">No client admin assigned yet.</p>
                    )}
                  </div>
                )}

                <div>
                  <SectionHeader>Contract Terms</SectionHeader>

                  {/* Learner Seats + Creator Seats */}
                  <div className={`grid gap-3 mt-3 ${values.featureToggleMode === 'FULL_CREATOR' ? 'grid-cols-2' : 'grid-cols-1 max-w-xs'}`}>
                    <div>
                      <Label htmlFor="contractLearnerSeats">Learner Seats</Label>
                      <Input
                        id="contractLearnerSeats"
                        name="contractLearnerSeats"
                        type="number"
                        min="0"
                        value={values.contractLearnerSeats}
                        onKeyDown={(e) => e.key === '-' && e.preventDefault()}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        placeholder="0"
                        error={touched.contractLearnerSeats && errors.contractLearnerSeats}
                      />
                      <ErrMsg msg={touched.contractLearnerSeats && errors.contractLearnerSeats} />
                    </div>
                    {values.featureToggleMode === 'FULL_CREATOR' && (
                      <div>
                        <Label htmlFor="contractCreatorSeats">Content Creator Seats <span className="text-gray-400 font-normal">(max 10)</span></Label>
                        <Input
                          id="contractCreatorSeats"
                          name="contractCreatorSeats"
                          type="number"
                          min="0"
                          max="10"
                          value={values.contractCreatorSeats}
                          onKeyDown={(e) => e.key === '-' && e.preventDefault()}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          placeholder="0"
                          error={touched.contractCreatorSeats && errors.contractCreatorSeats}
                        />
                        <ErrMsg msg={touched.contractCreatorSeats && errors.contractCreatorSeats} />
                      </div>
                    )}
                  </div>

                  {/* Start Date / End Date */}
                  <div className="grid grid-cols-2 gap-3 mt-3">
                    <div>
                      <Label htmlFor="contractStartDate">Start Date</Label>
                      <Input
                        id="contractStartDate"
                        name="contractStartDate"
                        type="date"
                        value={values.contractStartDate}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        error={touched.contractStartDate && errors.contractStartDate}
                      />
                      <ErrMsg msg={touched.contractStartDate && errors.contractStartDate} />
                    </div>
                    <div>
                      <Label htmlFor="contractEndDate">End Date</Label>
                      <Input
                        id="contractEndDate"
                        name="contractEndDate"
                        type="date"
                        value={values.contractEndDate}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        error={touched.contractEndDate && errors.contractEndDate}
                      />
                      <ErrMsg msg={touched.contractEndDate && errors.contractEndDate} />
                    </div>
                  </div>

                
                  {/* Amount + Currency */}
                  <div className="grid grid-cols-2 gap-3 mt-3">
                    <div>
                      <Label htmlFor="contractCurrency">Currency</Label>
                      <SelectField
                        options={[
                          { code: 'INR', description: 'INR - Indian Rupee' },
                          { code: 'USD', description: 'USD - US Dollar' },
                        ]}
                        value={values.contractCurrency ? { code: values.contractCurrency, description: values.contractCurrency } : null}
                        onChange={(val) => setFieldValue('contractCurrency', val.code)}
                        placeholder="Select currency"
                        error={touched.contractCurrency && errors.contractCurrency}
                        getLabel={(o) => o?.description || o || ''}
                      />
                      <ErrMsg msg={touched.contractCurrency && errors.contractCurrency} />
                    </div>
                    <div>
                      <Label htmlFor="contractAmount">Contract Amount</Label>
                      <Input
                        id="contractAmount"
                        name="contractAmount"
                        type="number"
                        min="0"
                        value={values.contractAmount}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        placeholder="e.g. 5000"
                        error={touched.contractAmount && errors.contractAmount}
                      />
                      <ErrMsg msg={touched.contractAmount && errors.contractAmount} />
                    </div>
                  </div>

                  {/* Coupon Code */}
                  <div className="mt-3">
                    <Label htmlFor="couponCode">Coupon Code <span className="text-gray-400 font-normal">(optional)</span></Label>
                    <Input
                      id="couponCode"
                      name="couponCode"
                      type="text"
                      value={values.couponCode}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      placeholder="e.g. DISCOUNT20"
                    />
                  </div>

                  {/* Pay Now toggle */}
                  <div className="mt-3 flex items-center gap-3">
                    <Label htmlFor="payNow">Pay Now</Label>
                    <button
                      type="button"
                      onClick={() => setFieldValue('payNow', !values.payNow)}
                      className={`relative inline-flex h-5 w-9 items-center rounded-full transition-colors ${values.payNow ? 'bg-blue-600' : 'bg-gray-300'}`}
                    >
                      <span
                        className={`inline-block h-3.5 w-3.5 transform rounded-full bg-white transition-transform ${values.payNow ? 'translate-x-4' : 'translate-x-1'}`}
                      />
                    </button>
                    <span className="text-[12px] text-gray-500">
                      {values.payNow ? 'Invoice will be sent immediately' : 'Invoice will be sent after trial ends'}
                    </span>
                  </div>
                
                  {/* Trial Period Days — only show if payNow is false */}
                  {!values.payNow && (
                    <div className="mt-3">
                      <Label htmlFor="trialPeriodDays">Trial Period (days)</Label>
                      <Input
                        id="trialPeriodDays"
                        name="trialPeriodDays"
                        type="number"
                        min="0"
                        value={values.trialPeriodDays}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        placeholder="e.g. 14 or 30, enter 0 for no trial"
                      />
                    </div>
                  )}

                      {/* Notes */}
                  <div className="mt-3">
                    <Label htmlFor="contractNotes">Notes</Label>
                    <textarea
                      id="contractNotes"
                      name="contractNotes"
                      value={values.contractNotes}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      rows={3}
                      placeholder="Internal notes about this contract…"
                      className="w-full border border-gray-300 rounded px-3 py-[7px] text-[13px] text-gray-800 placeholder-gray-400 focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-500 bg-white resize-none"
                    />
                  </div>
                </div>
              </div>
            )}

            <div className="flex items-center justify-end gap-2 px-5 py-3 border-t border-gray-200 bg-white">
              <button
                type="button"
                onClick={toggle}
                className="px-4 py-[7px] text-[13px] font-medium text-gray-700 border border-gray-300 rounded-md hover:bg-gray-50 transition"
              >
                Cancel
              </button>
              <button
                type="submit"
                disabled={loading}
                className="px-5 py-[7px] text-[13px] font-medium text-white bg-blue-600 rounded-md hover:bg-blue-700 disabled:opacity-60 transition flex items-center gap-2"
              >
                {loading && (
                  <svg className="animate-spin w-3.5 h-3.5" fill="none" viewBox="0 0 24 24">
                    <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
                    <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8H4z" />
                  </svg>
                )}
                {mode === 'create' ? 'Create Client Admin' : 'Save Changes'}
              </button>
            </div>
          </Form>
        )}
      </Formik>

      <SnackBar open={openSnackbar} snackbarTitle={snackbarTitle} close={() => setOpenSnackbar(false)} />
    </>
  );
}